// Local Docker uses separate browser/server media origins; production uses one.
export const newsImageUrl = (path: string) =>
  `${
    process.env.NEXT_PUBLIC_NEWS_MEDIA_URL ||
    process.env.NEXT_PUBLIC_MEDIA_URL ||
    ''
  }${path}`
